@switch (action().type) {
  @case (ActionButtonType.Command) {
    <p-button
      [styleClass]="action().variant | actionButtonVariantCss"
      [disabled]="action() | actionButtonDisability | trueOrFalse"
      (onClick)="action().command!()"
      [label]="action().label"
      appPrimengButton />
  }
  @case (ActionButtonType.RouterLink) {
    <a
      [routerLink]="action().routerLink!"
      [queryParams]="$any(action().queryParams)"
      [queryParamsHandling]="$any(action().queryParamsHandling)"
      [target]="action().target!">
      <p-button
        [styleClass]="action().variant | actionButtonVariantCss"
        [disabled]="action() | actionButtonDisability | trueOrFalse"
        [label]="action().label"
        appPrimengButton
        tabindex="-1" />
    </a>
  }
  @case (ActionButtonType.Url) {
    <a
      [href]="action().url!"
      [target]="action().target!">
      <p-button
        [styleClass]="action().variant | actionButtonVariantCss"
        [disabled]="action() | actionButtonDisability | trueOrFalse"
        [label]="action().label"
        appPrimengButton
        tabindex="-1" />
    </a>
  }
  @default {
    Nieznany typ "{{ action().type }}".
  }
}
